// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"acfddeed","771":"acfddeed"}[chunkId] + ".chunk.css";
};